var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleMeet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4485_36483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6797 32.0409L41.1389 38.2809L48.4797 42.9721L49.7597 32.0793L48.4797 21.4297L40.9981 25.5513L35.6797 32.0409Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 41.9591V51.2391C4 53.3607 5.7184 55.0791 7.84 55.0791H17.12L19.04 48.0647L17.12 41.9591L10.752 40.0391L4 41.9591Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.12 9L4 22.12L10.752 24.04L17.12 22.12L19.008 16.0976L17.12 9Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.12 22.1191H4V41.9591H17.12V22.1191Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8641 14.5543L48.4801 21.4279V42.9703L56.9025 49.8759C58.1633 50.8615 60.0065 49.9623 60.0065 48.3591V16.0391C60.0065 14.4167 58.1217 13.5271 56.8641 14.5543ZM35.6801 32.0391V41.9591H17.1201V55.0791H44.6401C46.7617 55.0791 48.4801 53.3607 48.4801 51.2391V42.9703L35.6801 32.0391Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6401 9H17.1201V22.12H35.6801V32.04L48.4801 21.4352V12.84C48.4801 10.7184 46.7617 9 44.6401 9Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_36483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 46.08,
    fill: "white",
    transform: "translate(4 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/googleMeet.0375e3255f91444523f9096e03ac4512.svg";
export { ForwardRef as ReactComponent };